import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { TEAM_DASHBOARD_FILTER_SOURCE, SCOPE_CONTEXT_FILTER_KEYS } from '@/analytics/snowplow/filterTracking';
import { useTrackFilterChanges } from '@/analytics/snowplow/hooks/useTrackFilterChanges';
import { unwrappedTeamDashboardWidgetsAtom } from '@/atoms/queries/userConfigs';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';
import { teamIdAtom } from '@/atoms/team/team';
import { ContentState } from '@/components/contentState/ContentState';
import { PageTitle } from '@/components/head/PageTitle';
import { DashboardContent, DashboardContentHeading } from '@/components/layout/DashboardContent';
import { DashboardContentFallback } from '@/components/layout/DashboardContentFallback';
import { TeamLayoutWithFilters } from '@/components/layout/team/TeamLayoutWithFilters';
import { useEntityPageTitle } from '@/hooks/useEntityPageTitle';
import { StatusTranslationKey } from '@/types/status';

const TeamDashboardWithData = () => {
  const teamId = useAtomValue(teamIdAtom);
  const teamDashboardWidgets = useAtomValue(unwrappedTeamDashboardWidgetsAtom);
  if (teamDashboardWidgets === undefined)
    return (
      <DashboardContentHeading>
        <ContentState status={StatusTranslationKey.LOADING} />
      </DashboardContentHeading>
    );
  return <DashboardContent entityId={teamId} dashboardWidgets={teamDashboardWidgets} />;
};

export const TeamDashboardPage = () => {
  const { t } = useTranslation('navigation');
  const teamName = useAtomValue(unwrappedSelectedTeamNameAtom);
  const heading = t('secondary.dashboard');
  const pageTitle = useEntityPageTitle(heading, teamName);
  useTrackFilterChanges(SCOPE_CONTEXT_FILTER_KEYS, TEAM_DASHBOARD_FILTER_SOURCE);

  return (
    <>
      <PageTitle>{pageTitle}</PageTitle>
      <TeamLayoutWithFilters>
        <DashboardContentFallback>
          <TeamDashboardWithData />
        </DashboardContentFallback>
      </TeamLayoutWithFilters>
    </>
  );
};
